import styled from "@emotion/styled";
import { alpha, Box, Divider, Grid, InputBase, Stack, Typography } from "@mui/material";
import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import { Send } from "@mui/icons-material";

function Messages() {
  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    //padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right:0
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
     
    width: "100%",
      
     
      [theme.breakpoints.up("md")]: {
        width: "55ch",
      },
    },
  }));

  return (
    <Box>
      <Box maxHeight={600} overflow="auto">
       <Box  mb={4} sx={{ marginRight: "150px",}}>
        <Stack direction={'row'} justifyContent="space-between">

        <Typography variant="">7.00 am</Typography>
          <Typography variant="">Unread</Typography>
        </Stack>

       <Stack
          sx={{
            background: "#D0E5E8",
            padding: 2,
           
            borderRadius: "10px",
          }}
          direction="column"
          gap="10px"
         
        >
          <Typography variant="">Readul</Typography>
          <Typography variant="">How About you ?</Typography>
        </Stack>
       </Box>
       <Divider light sx={{marginY:'20px'}}>yesterday</Divider>

       <Box  mb={4} sx={{ marginLeft: "150px",}}>
        <Stack direction={'row'} justifyContent="space-between">

        <Typography variant="">Unread</Typography>
          <Typography variant="">8.00 am</Typography>
        </Stack>

       <Stack
          sx={{
            background: "#D0E5E8",
            padding: 2,
           
            borderRadius: "10px",
          }}
          direction="column"
          gap="10px"
         
        >
          <Typography variant="">Himanshu</Typography>
          <Typography variant="">How About you ?</Typography>
        </Stack>
       </Box>
       
      <Divider  fullWidth light sx={{background:'blue',marginTop:'40px',marginBottom:'10px'}} />
      </Box>
      <Search>
        <SearchIconWrapper>
        <Send color="primary" fontSize="large"/>
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search…"
          inputProps={{ "aria-label": "search" }}
        />
      </Search>
    </Box>
  );
}

export default Messages;
